export default __webpack_public_path__ + "static/media/image_cute_dog.aee42abb.png";